import { DASHBOARD_SECTIONS_ROUTES } from '@/models/common/permissions.model';
import { DASHBOARD_META_TITLES } from '@/models/common/meta-titles.model';
import { RouteComponent, RouteRecordRaw } from 'vue-router';

export const statisticsRoutes: RouteRecordRaw[] = [
  {
    name: DASHBOARD_SECTIONS_ROUTES.STATISTICS,
    path: DASHBOARD_SECTIONS_ROUTES.STATISTICS,
    meta: { title: DASHBOARD_META_TITLES.STATISTICS_PAGE },
    component: async (): Promise<RouteComponent> =>
      await import('@/layouts/statistics/statistics-page.vue'),
  },
];
